import { palette } from 'assets/styles/colors';

interface PaletteColor {
  light?: string;
  main: string;
  dark?: string;
  contrastText?: string;
}
declare module '@mui/material/styles' {
  // add custom colors here
  interface Palette {
    white: string;
    gray: string;
    orange: string;
    neutral: PaletteColor;
  }
}

const primaryColor = palette.blue[500];
const secondaryColor = palette.cactus[500];
const white = '#FFFFFF';
const orange = '#E5672A';
const gray = '#c0c7ca';

const colors = {
  palette: {
    white,
    orange,
    gray,

    primary: {
      light: palette.blue[400],
      main: primaryColor,
      dark: palette.blue[600],
    },

    secondary: {
      main: secondaryColor,
    },

    neutral: {
      light: palette.neutral[50],
      main: palette.neutral[100],
      dark: palette.neutral[200],
    },

    text: {
      primary: primaryColor,
      secondary: secondaryColor,
    },

    info: {
      main: palette.sunshine[500],
    },
  },
};

export default colors;
